import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const DictionaryConvertToastError = ({ dictionaryName, isNew }) => {
  const createOrUpdate = isNew ? 'dataset.convert.toast.create.error' : 'dataset.convert.toast.update.error';
  return (
    <div className="aridhia-error-toast toast-deleted toast-message">
      <Icon name="times circle" color="red" />
      <FormattedMessage id={createOrUpdate} values={{ dictionaryName }} />
    </div>
  );
};

export default DictionaryConvertToastError;
